import React, { useState } from "react";
import GoogleMapReact from "google-map-react";
import { Paper, Typography, useMediaQuery } from "@material-ui/core";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
// import Rating from "@material-ui/lab/Rating";
import Rating from "./Rating";
import hotel from "./hotel.png";
import map_pin from "./map-pin.svg";

import useStyles from "./styles";

export default function Map({
  setCoordinates,
  setBounds,
  coordinates,
  setChildClicked,
  zoom,
  setZoom,
  places,
}) {
  const [searchEnabled, setSearchEnabled] = useState(false);
  const [hoveredPlace, setHoveredPlace] = useState(null);

  const handleCheckboxChange = (e) => {
    setSearchEnabled(e.target.checked);
  };

  const handleMarkerHover = (i) => {
    setHoveredPlace(i);
  };

  const handleMarkerLeave = () => {
    setHoveredPlace(null);
  };

  const classes = useStyles();
  const isDesktop = useMediaQuery("(min-width: 600px)");

  return (
    <div className="h-[100%] w-[100%] relative">
      <div className="absolute top-10 left-64 z-20 bg-white rounded-3xl p-2">
        <label htmlFor="search-checkbox" className="flex items-center space-x-2">
          <input
            className="w-5 h-5"
            id="search-checkbox"
            type="checkbox"
            checked={searchEnabled}
            onChange={handleCheckboxChange}
          />
          <span className="text-base font-medium">Search as I move the map</span>
        </label>
      </div>

      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
        center={coordinates}
        zoom={zoom}
        setZoom={setZoom}
        margin={[50, 50, 50, 50]}
        options={""}
        onChange={(e) => {
          if (searchEnabled) {
            setBounds({ ne: e.marginBounds.ne, sw: e.marginBounds.sw });
          }
          setCoordinates({ lat: e.center.lat, lng: e.center.lng });
        }}
        onChildClick={(child) => setChildClicked(child)}
      >
        {places?.map((place, i) => (
          <div
            className={classes.markerContainer}
            lat={Number(place.latitude)}
            lng={Number(place.longitude)}
            key={i}
          >
            {!isDesktop ? (
              <LocationOnOutlinedIcon color="primary" fontSize="large" />
            ) : (
              <img
                src={hotel}
                alt={place.name}
                className="w-6 z-1"
                onMouseEnter={() => handleMarkerHover(i)}
                onMouseLeave={handleMarkerLeave}
            
              />
            )}
          </div>
        ))}

        {hoveredPlace !== null && (
          <div
            className={classes.markerContainer}
            lat={Number(places[hoveredPlace]?.latitude)}
            lng={Number(places[hoveredPlace]?.longitude)}
            onMouseEnter={() => handleMarkerHover(hoveredPlace)}
            onMouseLeave={handleMarkerLeave}
            // className="z-50"
          >
            <Paper elevation={3}  className="z-50 p-4 flex flex-col justify-center w-24">
              <Typography className={classes.typography} variant="subtitle2" gutterBottom>
                {places[hoveredPlace].name}
              </Typography>
              <img
                className={classes.pointer}
                src={
                  places[hoveredPlace]?.photo?.images?.large?.url ||
                  "https://media-cdn.tripadvisor.com/media/photo-s/11/e8/ee/a8/chaiyum-special-masala.jpg&quot"
                }
                alt={places[hoveredPlace].name}
              />
              <div className="mt-2">
              <Rating  value={Number(places[hoveredPlace].rating)} />
              </div>
              
            </Paper>
          </div>
        )}

<img
          src={map_pin} // Corrected source attribute
          alt="Map Pin"
          lat={coordinates.lat}
          lng={coordinates.lng}
          className="w-10"
        />
      </GoogleMapReact>
    </div>
  );
}
